module.exports = __webpack_public_path__ + "assets/media/2.d368157f.wav";